import React from 'react';

/**
 * PageSEO Component for React 19
 * Provides SEO meta tags, canonical URLs, and structured data
 * React 19 automatically hoists these tags to <head>
 */
const PageSEO = ({ 
  title, 
  description, 
  canonicalUrl,
  breadcrumbs = [],
  schema = null,
  noIndex = false
}) => {
  // Build BreadcrumbList Schema if breadcrumbs provided
  const breadcrumbSchema = breadcrumbs.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": crumb.url
    }))
  } : null;

  return (
    <>
      {/* Title */}
      <title>{title}</title>
      
      {/* Meta Tags */}
      <meta name="description" content={description} />
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Language */}
      <link rel="alternate" hrefLang="de-DE" href={canonicalUrl} />
      <meta httpEquiv="content-language" content="de-DE" />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      
      {/* Twitter Card */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {/* BreadcrumbList Schema */}
      {breadcrumbSchema && (
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />
      )}
      
      {/* Additional Schema (e.g., LocalBusiness, FAQPage) */}
      {schema && (
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      )}
    </>
  );
};

export default PageSEO;
